import { Capacitor } from '@capacitor/core';

// Browser deployments serve /api on the current site (or its development proxy).
// Native apps have no HTTP site of their own and need the configured server.
export function getApiBase() {
  const saved = typeof localStorage !== 'undefined' ? localStorage.getItem('wenjing_api_base') : '';
  return saved || (Capacitor.isNativePlatform() ? import.meta.env?.VITE_API_BASE_URL || '' : '');
}
